import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconGoogleComponent } from "./med-icon-google.component";

@NgModule({
  declarations: [
    MedIconGoogleComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconGoogleComponent,
  ],
})
export class MedIconGoogleModule { }
